import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { StoreIcon, EStoreIconType } from '@common/components/StoreIcon';

import { IStoresProps } from './types';

import * as s from './Stores.scss';

export const Stores = ({
	className,
	from,
	isIconFilled,
	isLanding,
	isVertical,
}: IStoresProps) => {
	const {
		isAppStoreAvailable,
		isGooglePlayAvailable,
		isHuaweiAppGalleryAvailable,
		isMobile,
	} = getConfig();

	const shouldShowAllStores = !isAppStoreAvailable && !isGooglePlayAvailable && !isHuaweiAppGalleryAvailable;

	const googlePlay = (
		(isGooglePlayAvailable || !isMobile || shouldShowAllStores) && (
			<StoreIcon
				className={cn(s.store, {
					[s.storeLanding]: isLanding,
				})}
				type={EStoreIconType.GOOGLE_PLAY}
				isFilled={isIconFilled}
				isMonochrome={isLanding}
				from={from}
			/>
		)
	);

	const appStore = (
		(isAppStoreAvailable || !isMobile || shouldShowAllStores) && (
			<StoreIcon
				className={cn(s.store, {
					[s.storeLanding]: isLanding,
				})}
				type={EStoreIconType.APP_STORE}
				isFilled={isIconFilled}
				isMonochrome={isLanding}
				from={from}
			/>
		)
	);

	const huaweiAppGallery = (
		(isHuaweiAppGalleryAvailable || !isMobile || shouldShowAllStores) && (
			<StoreIcon
				className={cn(s.store, {
					[s.storeLanding]: isLanding,
				})}
				type={EStoreIconType.HUAWEI_APP_GALLERY}
				isFilled={isIconFilled}
				isMonochrome={isLanding}
				from={from}
			/>
		)
	);

	return (
		<div className={cn(s.block, className, {
			[s.column]: isVertical || (isMobile && shouldShowAllStores && !isLanding),
			[s.columnLanding]: isMobile && shouldShowAllStores && isLanding,
		})}>
			{isLanding ? (
				<>
					{googlePlay}
					{appStore}
					{huaweiAppGallery}
				</>
			): (
				<>
					{appStore}
					{googlePlay}
					{huaweiAppGallery}
				</>
			)}
		</div>
	);
};
